/**
 * 周边设施 Markers
 * 
 * @Author: Focci
 * @Date: 2023-07-18 15:24:29
 * @Last Modified by: Focci
 * @Last Modified time: 2023-07-18 15:24:29
 */

import PropTypes from 'prop-types'
import busIcon from '@img/facility/ic_business_bus.png'
import cafeIcon from '@img/facility/ic_business_cafe.png'
import restaurantIcon from '@img/facility/ic_business_restaurant.png'
import gymIcon from '@img/facility/ic_business_gym.png'
import mallIcon from '@img/facility/ic_business_mall.png'
import bankIcon from '@img/facility/ic_business_bank.png'
import hospitalIcon from '@img/facility/ic_business_hospital.png'
import localIcon from '@img/facility/ic_business_local.png'
import clubIcon from '@img/facility/ic_business_night_club.png'

import { useMap } from 'react-map-gl'
import { useCallback } from 'react'
import { useMapState, fitBounds } from '@comp/mapbox'
import { isArray, map, pick } from 'lodash-es'
import Markers from './Markers'

const icons = {
  transit_station: busIcon.src,
  cafe: cafeIcon.src,
  restaurant: restaurantIcon.src,
  gym: gymIcon.src,
  shopping_mall: mallIcon.src,
  bank: bankIcon.src,
  hospital: hospitalIcon.src,
  local_government_office: localIcon.src,
  night_club: clubIcon.src,
}

function handleDataFilter(data, type) {
  const props = ['name', 'vicinity', 'rating', 'id', 'place_id', 'reference']
  
  return isArray(data) 
    ? map(data, (item) => {
      const { lng, lat } = item.geometry.location
      return { ...pick(item, props), lng, lat, icon: icons[type] }
    })
    : []
}

export default function FacilityMarkers({
  houseId = null,
  type = '',
  ...markerProps
}) {
  const { current } = useMap()
  const { facility, facilityPanel } = useMapState()

  const handleDataUpdate = useCallback((points) => {
    const tmp = map(isArray(points) ? points : [], (item) => pick(item, ['lng', 'lat']))
    fitBounds(current, tmp, 100)
  }, [current])
  
  if(!(facilityPanel && facility && facility === type)) {
    return null
  }
  
  return (
    <Markers
      url={`house-places/${houseId}/${type}`}
      moveMapRefetchMarkers={false}
      dataFilter={(d) => handleDataFilter(d, type)}
      type="facility"
      onDataUpdate={handleDataUpdate}
      {...markerProps}
    />
  )
}

FacilityMarkers.propTypes = {
  houseId: PropTypes.number,
  type: PropTypes.string,
}
